import { useNavigate } from "react-router-dom";
import searchIcon from "../../assets/images/search_rgb_red.svg";
import checkboxIcon from "../../assets/images/check_box_rgb_red.svg";
import filterIcon from "../../assets/images/filter_rgb_red.svg";
import downloadIcon from "../../assets/images/download_rgb_red.svg";
import {
  Button,
  Col,
  Container,
  Row,
  OverlayTrigger,
  Tooltip,
  Spinner,
} from "react-bootstrap";
import React from "react";
import "../../assets/styles/addresses.scss";
import { useFileExport } from "../../hooks/useFileExport";

const AddressesButtons = ({ onSearch, selectedIds = [], filters = {} }) => {
  const navigate = useNavigate();
  const [isPreparingDownload, setIsPreparingDownload] = React.useState(false);

  const handleEditSelected = () => {
    if (selectedIds.length === 0) {
      alert("Proszę wybrać co najmniej jeden rekord do edycji.");
      return;
    }

    // Navigate to bulk update page with selected IDs
    const idsParam = selectedIds.join(",");
    navigate(`/information/bulkupdate?ids=${idsParam}`);
  };

  const { exportFile, isExporting, exportProgress } = useFileExport(
    "/Address/Csv",
    "addresses.csv"
  );
  const isDownloadBusy = isPreparingDownload || isExporting;
  
  const handleDownloadCsv = async () => {
    if (isDownloadBusy) return;

    setIsPreparingDownload(true);
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v !== undefined && v !== null && v !== "") {
            queryParams.append(key, String(v));
          }
        });
      } else if (typeof value === "object") {
        const v = value.value ?? value.label ?? String(value);
        if (v) queryParams.append(key, String(v));
      } else {
        queryParams.append(key, String(value));
      }
    });
    const qs = queryParams.toString();
    if (!qs) {
      setIsPreparingDownload(false);
      alert(
        "Proszę wprowadzić co najmniej jeden filtr przed eksportem do pliku."
      );
      return;
    }

    const filtersToExport = Object.fromEntries(
      [...queryParams.entries()].map(([k, v]) => [k, v])
    );

    try {
      await exportFile(filtersToExport);
     
    } catch (e) {
      alert("Wystąpił błąd podczas eksportu CSV.");
    } finally {
      setIsPreparingDownload(false);
    }
  };

  const handleEditWithFilters = () => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v !== undefined && v !== null && v !== "") {
            queryParams.append(key, String(v));
          }
        });
      } else if (typeof value === "object") {
        const v = value.value ?? value.label ?? String(value);
        if (v) queryParams.append(key, String(v));
      } else {
        queryParams.append(key, String(value));
      }
    });
    navigate(`/information/bulkupdate?${queryParams.toString()}`);
  };

  const renderEditTooltip = (props) => (
    <Tooltip id="edit-tooltip" {...props}>
      Edytuj zaznaczone ({selectedIds.length})
    </Tooltip>
  );

  const renderEditFilterTooltip = (props) => (
    <Tooltip id="edit-filter-tooltip" {...props}>
      Edytuj wszystkie spełniające filtr
    </Tooltip>
  );

  const renderDownloadTooltip = (props) => (
    <Tooltip id="download-tooltip" {...props}>
      Eksportuj dane spełniające kryteria
    </Tooltip>
  );

  return (
    <Container>
      <Row className="justify-content-center">
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderEditTooltip}
          >
            <Button className="addresses-button" onClick={handleEditSelected}>
              <img
                src={checkboxIcon}
                alt="Edit Selected"
                style={{ width: "75%", height: "75%" }}
              />
            </Button>
          </OverlayTrigger>
        </Col>
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderEditFilterTooltip}
          >
            <Button
              className="addresses-button"
              onClick={handleEditWithFilters}
            >
              <img
                src={filterIcon}
                alt="EditFilter"
                style={{ width: "75%", height: "75%" }}
              />
            </Button>
          </OverlayTrigger>
        </Col>
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderDownloadTooltip}
          >
            <Button className="addresses-button" onClick={handleDownloadCsv} disabled={isDownloadBusy}>
              {isDownloadBusy ? (
                <div className="d-flex flex-column align-items-center justify-content-center" style={{ width: "100%", height: "100%", lineHeight: 1 }}>
                  <Spinner animation="border" size="sm" />
                  {isExporting && exportProgress > 0 && (
                    <small style={{ fontSize: "0.6rem", marginTop: "4px" }}>{exportProgress}%</small>
                  )}
                </div>
              ) : (
                <img
                  src={downloadIcon}
                  alt="Download"
                  style={{ width: "75%", height: "75%" }}
                />
              )}
            </Button>
          </OverlayTrigger>
        </Col>
        <Col xs="auto">
          <Button className="addresses-button" onClick={onSearch}>
            <img
              src={searchIcon}
              alt="Search"
              style={{ width: "75%", height: "75%" }}
            />
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default AddressesButtons;
